<template>
	<v-container class="d-flex flex-row justify-end task-manager-container pa-0" :class="$vuetify.breakpoint.mobile ? '':'desktop-layout'">
		<!-- Móvil: botón que abre un menú agrupado -->
		<div v-if="mobileMenuNeeded && $store.globalStore.state.openTasksHandler && $store.globalStore.state.openTasksHandler.length > 0" class="mobile-only d-flex align-center mb-2">
			<v-menu
				v-model="mobileMenuOpen"
				offset-y
				offset-x
				:bottom="!$vuetify.breakpoint.mobile"
				:left="!$vuetify.breakpoint.mobile"
				:top="$vuetify.breakpoint.mobile"
				:right="$vuetify.breakpoint.mobile"
				:nudge-top="$vuetify.breakpoint.mobile ? 15 : 0"
				max-width="340"
				min-width="280">
				<template v-slot:activator="{ on, attrs }">
					<v-badge
						:content="$store.globalStore.state.openTasksHandler ? $store.globalStore.state.openTasksHandler.length : 0"
						:value="$store.globalStore.state.openTasksHandler && $store.globalStore.state.openTasksHandler.length > 0"
						overlap
						color="#5E85EF"
					>
						<v-btn small class="task-btn" v-bind="attrs" v-on="on">
							<v-icon class="mr-1">mdi-format-list-bulleted</v-icon>
							<span>Items Minimizados</span>
						</v-btn>
					</v-badge>
				</template>

				<v-card class="tasks-panel">
					<v-card-title class="panel-header">
						<span>Items Minimizados ({{ $store.globalStore.state.openTasksHandler ? $store.globalStore.state.openTasksHandler.length : 0 }})</span>
						<v-btn icon x-small color="white" @click.stop="mobileMenuOpen = false"><v-icon>mdi-close</v-icon></v-btn>
					</v-card-title>

					<v-card-text class="pa-2">
						<div v-if="!$store.globalStore.state.openTasksHandler || !$store.globalStore.state.openTasksHandler.length" class="no-items pa-2">No hay items</div>
						<div
							v-for="(task, index) in $store.globalStore.state.openTasksHandler"
							:key="'m' + index"
							class="task-item"
							@click="handleView(task, index)">
							<div class="task-left">
								<v-icon size="18" class="mr-2">mdi-clipboard-text-outline</v-icon>
								<div class="task-info">
									<p class="task-title mb-0 text-truncate"><span v-if="task.number">#{{task.number}} - </span>{{task.title}}</p>
									<p class="task-type mb-0 type-text">{{task.type}}</p>
								</div>
							</div>

							<v-btn icon x-small @click.stop="closeTask(index)"><v-icon size="16">mdi-close-circle</v-icon></v-btn>
						</div>
					</v-card-text>
				</v-card>
			</v-menu>
		</div>
		<!-- Desktop: mostrar items minimizados -->
		<div v-else class="task-manager-inner-container py-1 pl-4 pr-6 mx-1 desktop-only"
			v-for="(task, index) in $store.globalStore.state.openTasksHandler"
			:key="index"
			@click="handleView(task, index)">
			<div>
				<p class="mb-0 text--secondary type-text">{{task.type}}</p>
				<p class="caption mb-0 light-blue-text font-weight-bold"><span v-if="task.number">#{{task.number}} - </span>{{task.title}}</p>
			</div>
			<v-icon class="close-icon" color="#5E85EF" small @click.stop="closeTask(index)">mdi-close-circle</v-icon>
		</div>

	</v-container>
</template>

<script>
import {getTareaByID} from '@/helpers/api/tasks'
import {getRdiByID} from '@/helpers/api/rdi'
import {getDraftByID} from '@/helpers/api/drafts'
import { getEntregaByID, getConfig } from "@/helpers/api/entrega";
import { getJobTypes } from "@/helpers/api/user";

export default {
	name: 'TasksManager',
	components: { },
	filters: {
	},
		data: () => ({
			mobileMenuOpen: false
		}),
		computed: {
			selectedProject() {
				return this.$store.projectsStore.state.selectedProject;
			},
			mobileMenuNeeded(){
				const list = (this.$store && this.$store.globalStore && this.$store.globalStore.state && this.$store.globalStore.state.openTasksHandler) || []
				return this.$vuetify.breakpoint.mobile || list.length > 5
			}
		},
		mounted(){
		},
	methods: {
		closeTask(index){
			this.$store.globalStore.commit('removeTaskFromTasksHandler', index)
		},
		async handleView(task, index){
			this.mobileMenuOpen = false
			if(task.draft_id){
				const draftData = await getDraftByID({id: task.draft_id})
				if(draftData.code === 200){
					const draft = this.parseData(draftData.draft)
					this.loadDraft(draft, index)
					this.closeTask(index)
					return
				}
			}
			if(task.type_id == 1){
				this.viewTarea(task.task_id, index)
			}
			else if(task.type_id == 2){
				this.viewRDI(task.task_id, index)
			}
			else if(task.type_id == 3){
				if(task.draft_id){
					const draftData = await getDraftByID({id: task.draft_id})
					if(draftData.code === 200){
						const draft = this.parseData(draftData.draft)
						this.loadDraft(draft)
						this.closeTask(index)
						return
					}
				}

				this.$store.consultasStore.commit('setBorradorTarea', task.newTaskForm)
				if(task.is_posible_additional){
					this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
				}
				else{
					this.$store.consultasStore.commit('setCreateTareaModal', true)
				}
				this.closeTask(index)
			}
			else if(task.type_id == 4){
				this.$store.rdiStore.commit('setBorradorRDI', task.newRDIForm)
				this.$store.rdiStore.commit('setCreateRDIModal', true)
				this.closeTask(index)
			}
			else if(task.type_id == 5){
				this.viewAdditional(task.task_id, index)
			}
			else if(task.type_id == 6){
				if(task.draft_id){
					const draftData = await getDraftByID({id: task.draft_id})
					if(draftData.code === 200){
						const draft = this.parseData(draftData.draft)
						this.loadDraft(draft)
						this.closeTask(index)
						return
					}
				}

				this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
				this.closeTask(index)
			}
			else if(task.type_id == 7){
				this.viewEntrega(task.task_id, index)
			}
			else if(task.type_id == 9){
				if(task.draft_id) {
					const draftData = await getDraftByID({id: task.draft_id})
					if(draftData.code === 200) {
						const draft = this.parseData(draftData.draft)
						this.loadDraft(draft, index)
						return
					}
				}
				this.$store.entregaStore.commit('setCreateEntregaModal', true)
				this.closeTask(index)
			}
		},
		async viewTarea(task_id, index, is_posible_additional = false){
			this.closeTask(index)
			this.$store.consultasStore.commit('setCurrentTarea', {loading: true, is_posible_additional})
			const tarea = await getTareaByID({task_id})
			if(tarea.code === 200){
				let tareaData = tarea.task
				tareaData.prev_seen_by_me = false
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		async viewRDI(rdi_id, index){
			this.closeTask(index)
			this.$store.rdiStore.commit('setCurrentRDI', {loading: true})
			const rdi = await getRdiByID({rdi_id})
			if(rdi.code === 200){
				let rdiData = rdi.rdi
				rdiData.prev_seen_by_me = false
				this.$store.rdiStore.commit('setCurrentRDI', rdiData)
			}
		},
		async viewAdditional(additional_id, index){
			this.closeTask(index)
			this.$store.adicionalesStore.dispatch('getAdditionalByID', {additional_id, seen_by_me: true})
		},
    async viewEntrega(entregaId, index) {
      if (!this.selectedProject) return;

			this.closeTask(index)
      const projectID = this.selectedProject.id;
      this.$store.entregaStore.commit("setCurrentEntrega", { loading: true });

      try {
        const entregaResponse = await getEntregaByID({ entrega_id: entregaId });
        const [configResponse, jobTypesResponse] = await Promise.all([
          getConfig({ project_id: projectID }),
          getJobTypes({ project_id: projectID }),
        ]);
        this.$store.usersStore.commit(
          "setJobTypes",
          jobTypesResponse.job_types
        );
        this.$store.entregaStore.commit("setConfig", configResponse.config);

				if (entregaResponse.code === 403) {
					this.$store.entregaStore.commit("setCurrentEntrega", null);
				} else if (entregaResponse.code === 200) {
          const entregaData = entregaResponse.entrega;
          entregaData.prev_seen_by_me = false;
          this.$store.entregaStore.commit("setCurrentEntrega", entregaData);

          // this.setStatusDescription(entregaData);
        }
      } catch (error) {
        console.error("Error loading entrega details:", error);
        this.$store.entregaStore.commit("setCurrentEntrega", {
          loading: false,
          error: true,
        });
      }
    },
		parseData(draft) {
			if (draft.data && typeof draft.data === 'string') {
				try {
					draft.data = JSON.parse(draft.data)
				} catch (error) {
					console.error('Error al parsear data del borrador:', error)
					draft.data = {}
				}
			}
			return draft
		},
		loadDraft(draft, index){
			const draftType = draft.raw_type
			
			if(draftType === 1) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.$store.consultasStore.commit('setCreateTareaModal', true)
			} else if(draftType === 2) {
				this.$store.rdiStore.commit('setDraftToLoad', draft)
				this.$store.rdiStore.commit('setCreateRDIModal', true)
			} else if(draftType === 3) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
			} else if(draftType === 4) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
			} else if(draftType === 5) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.viewTarea(draft.morphable_id, index)
			} else if(draftType === 6) {
				this.$store.rdiStore.commit('setDraftToLoad', draft)
				this.viewRDI(draft.morphable_id, index)
			} else if(draftType === 7) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.viewAdditional(draft.morphable_id, index)
			} else if(draftType === 8) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.viewTarea(draft.morphable_id, index, true)
			} else if(draftType === 9) {
				this.$store.entregaStore.commit('setDraftToLoad', draft)
				this.$store.entregaStore.commit('setCreateEntregaModal', true)
			}
			else {
				this.closeTask(index)
			}
		},
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.light-blue-text{color: #5E85EF;}
	.task-manager-container{
		position: fixed;
		bottom: 0;
		right: 30px;
		width: max-content;
		max-width: calc(100vw - 60px);
		max-height: 50px;
		pointer-events: none;
	}
	.task-manager-container.desktop-layout{
		right: 60px;
	}
	.task-manager-inner-container{
		pointer-events: auto;
		cursor: pointer;
		position: relative;
		background-color: white;
		border: 1px solid #cacaca;
		border-bottom: 0;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		min-width: 170px;
	}
	.close-icon{
		position: absolute;
		top: 1px;
		right: 1px;
		z-index: 99;
	}
	.type-text{
		font-size: 10px;
	}

	/* Responsive helpers: ocultar/mostrar según ancho */
	.desktop-only { display: flex; }
	.mobile-only { display: none; }

	.task-menu-btn{ background: white; }
	.task-count{ position: absolute; top: -6px; right: -6px; background: #5E85EF; color: white; font-size: 10px; line-height: 14px; padding: 0 6px; border-radius: 10px; }

	@media (max-width: 600px) {
		.desktop-only { display: none !important; }
		.mobile-only { display: flex !important; }
		.task-manager-container{ right: 12px; bottom: 12px; }
		.task-manager-inner-container{ min-width: 140px; }
		.task-menu-btn{ min-width: 44px; min-height: 44px; border-radius: 50%; box-shadow: 0 1px 6px rgba(0,0,0,0.12); }
	}

	/* Estilos tipo MinimizedFileManager para móvil */
	.task-btn {
		pointer-events: auto;
		background: linear-gradient(135deg, #2D4B95, #5E85EF);
		color: white;
		box-shadow: 0 4px 12px rgba(45,75,149,0.4);
		transition: all 0.25s ease;
	}
	.task-btn:hover { transform: translateY(-2px) scale(1.03); }

	.mini-label {
		font-size: 13px;
		margin-left: 8px;
		color: #333;
		align-self: center;
	}

	.tasks-panel {
		width: 320px;
		min-width: 280px;
		max-width: 340px;
		max-height: 400px;
		overflow-y: auto;
		border-radius: 12px;
		background: white;
		box-shadow: 0 8px 25px rgba(0,0,0,0.15);
	}

	.panel-header {
		background: #2D4B95;
		color: white;
		font-size: 14px;
		padding: 8px 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.task-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px;
		border-radius: 8px;
		background: #f5f7fa;
		margin-bottom: 6px;
		cursor: pointer;
		transition: all 0.2s ease;
	}

	.task-item:hover {
		background: #e8ecf5;
		transform: translateX(2px);
	}

	.task-left {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 0;
	}

	.task-info { min-width: 0; }

	.task-title {
		font-size: 12px;
		font-weight: 600;
		margin: 0;
	}

	.task-type {
		font-size: 10px;
		color: #888;
		margin: 0;
	}

	.no-items {
		color: #666;
		font-size: 13px;
	}

</style>